export default {
  0: '草稿',
  1: '审批中',
  2: '已同意',
  3: '已拒绝',
  4: '已删除',
};
